import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';

import * as ActionType from './types/WeddingActionTypes';
import { getWeddingThemeKey, getWeddingThemeGroupTitle } from '../selectors/website/websiteSelectors';

function requestWedding() {
  return {
    type: ActionType.REQUEST_WEDDING
  };
}

export function receiveWeddingAccount(json) {
  return {
    type: ActionType.RECEIVE_WEDDING_ACCOUNT,
    payload: {
      account: json
    }
  };
}

function receiveWedding(json) {
  return {
    type: ActionType.RECEIVE_WEDDING,
    payload: {
      wedding: json
    }
  };
}

function requestTheme() {
  return {
    type: ActionType.THEME_REQUESTED
  };
}

function receiveTheme(json) {
  return {
    type: ActionType.THEME_RECEIVED,
    payload: {
      theme: json
    }
  };
}

function requestThemeGroup() {
  return {
    type: ActionType.THEMEGROUP_REQUESTED
  };
}

function receiveThemeGroup(json) {
  return {
    type: ActionType.THEMEGROUP_RECEIVED,
    payload: {
      theme: json
    }
  };
}

// This may not be needed but i need to get something to prod
export function disableWebsiteOnboarding() {
  return {
    type: ActionType.DISABLE_WEBSITE_ONBOARDING
  };
}

export function enableGuestListOnboarding() {
  return {
    type: ActionType.ENABLE_GUEST_LIST_ONBOARDING
  };
}

export function enableGuestListTour() {
  return {
    type: ActionType.ENABLE_GUEST_LIST_TOUR
  };
}

export function fetchWedding() {
  return (dispatch) => {
    dispatch(requestWedding());
    return fetch('/web-api/v1/wedding',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWedding(json)));
  };
}

export function fetchWeddingAccount() {
  return (dispatch) => {
    dispatch(requestWedding());
    return fetch('/web-api/v1/weddingAccount',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWeddingAccount(json)))
      .catch(err => console.log('fetchweddingaccount err:', err));
  };
}

export function fetchWeddingThemeGroup(key) {
  return (dispatch) => {
    dispatch(requestThemeGroup());
    return fetch(`/web-api/v2/theme/${key}`,
      {
        credentials: 'same-origin',
      })
      .then(response => response.json())
      .then(json => dispatch(receiveThemeGroup(json)));
  };
}

export function fetchWeddingTheme() {
  return (dispatch) => {
    dispatch(requestTheme());
    return fetch('/web-api/v1/wedding/theme',
      {
        credentials: 'same-origin',
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTheme(json)))
      .then(json => dispatch(fetchWeddingThemeGroup(json.payload.theme.key)));
  };
}

export function fetchWeddingThemeV2(themeKey) {
  return (dispatch) => {
    dispatch(requestTheme());
    return fetch(`/web-api/v2/theme/${themeKey}`,
      {
        credentials: 'same-origin',
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTheme(json)));
  };
}

export function updateWeddingTheme(themeId) {
  return (dispatch, getState) => (
    fetch('/web-api/v1/wedding/theme',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          theme_id: themeId
        })
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTheme(json)))
      .then(() => dispatch(fetchWeddingThemeGroup(getWeddingThemeKey(getState()))))
      .then(() => dispatch(toastsActions.positive({ headline: `${getWeddingThemeGroupTitle(getState())} Design Selected` })))
  );
}

export function updateWebsitePublish(enable) {
  return dispatch => (
    fetch('/web-api/v1/weddingAccount/publish',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ enable })
      })
      .then(() => dispatch(fetchWeddingAccount()))
      .then(() => {
        if (enable) {
          // Send publish website optimizely event for current running test
          window.optimizely = window.optimizely || [];
          window.optimizely.push({
            type: 'event',
            eventName: 'Website Published'
          });
        }
      })
  );
}

export function updateSearchSettings(request) {
  return dispatch => (
    fetch('/web-api/v1/wedding/searchSettings',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'PUT',
        body: JSON.stringify(request)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWedding(json)))
  );
}

export const toggleWebsite = value => (dispatch) => {
  dispatch({ type: ActionType.TOGGLE_WEBSITE });
  return dispatch(updateWebsitePublish(value));
};

export function updateWeddingAccount(request) {
  return dispatch => (
    fetch('/web-api/v1/weddingAccount/update',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(request)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWeddingAccount(json)))
  );
}

export function updateWedding(request) {
  return dispatch => (
    fetch('/web-api/v1/wedding/update',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(request)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWedding(json)))
  );
}

export function updateShowPoiMap(hidden) {
  return (dispatch, getState) => {
    const weddingAccount = getState().wedding.account;
    weddingAccount.enable_poi_maps = hidden;
    dispatch(updateWeddingAccount(weddingAccount));
  };
}

export function updateGuestListOnboarding(enable) {
  return dispatch => (
    fetch('/web-api/v1/weddingAccount/guest_list_onboarding',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ enable })
      })
      .then(() => dispatch(fetchWeddingAccount()))
  );
}

export function updateFeatureFlag(uuid, flags) {
  return dispatch => (
    fetch('/web-api/v1/weddingAccount/features',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({uuid, flags})
      })
      .then(() => dispatch(fetchWeddingAccount()))
  );
}



// WEBPACK FOOTER //
// ./src/actions/WeddingActions.js